import { Link } from "react-router-dom";
import { Facebook, Instagram, Mail, Phone, Clock } from "lucide-react";

const SERVICE_AREAS = [
  "Ruakaka",
  "Waipu",
  "Langs Beach",
  "Mangawhai Heads",
  "Mangawhai",
  "Te Arai",
  "Pakiri",
  "Leigh",
  "Matakana",
  "Omaha",
  "Warkworth",
  "Snells Beach",
  "Orewa",
];

export default function Footer() {
  return (
    <footer className="bg-ink text-white">
      <div className="container grid gap-10 py-14 md:grid-cols-3">
        <div>
          <div className="mb-4 flex items-center gap-3">
            <img src="/images/coolwave-logo-white.svg" alt="Cool Wave" className="h-12 w-auto" style={{ maxWidth: 180 }} />
          </div>
          <p className="mb-5 text-sm text-white/70">For warm, dry, healthy homes.</p>
          <div className="text-xs uppercase tracking-wider text-white/50">Service area</div>
          <ul className="mt-2 grid grid-cols-2 gap-y-1 text-sm text-white/80">
            {SERVICE_AREAS.map((area) => (
              <li key={area}>{area}</li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white">Quick links</h3>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/" className="hover:text-brand">Home</Link></li>
            <li><Link to="/services" className="hover:text-brand">Services</Link></li>
            <li><Link to="/about" className="hover:text-brand">About</Link></li>
            <li><Link to="/free-quote" className="hover:text-brand">Free Quote</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white">Contact</h3>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-2">
              <Phone className="mt-0.5 h-4 w-4 flex-none text-brand" />
              <a href="tel:0272980080" className="min-w-0 flex-1 cursor-pointer [overflow-wrap:anywhere] hover:text-brand">027 298 0080</a>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="mt-0.5 h-4 w-4 flex-none text-brand" />
              <a href="mailto:gavin@coolwave.co.nz" className="min-w-0 flex-1 cursor-pointer [overflow-wrap:anywhere] hover:text-brand">gavin@coolwave.co.nz</a>
            </li>
            <li className="flex items-start gap-2">
              <Clock className="mt-0.5 h-4 w-4 flex-none text-brand" />
              <span className="min-w-0 flex-1">8am–5pm Mon–Fri<br /><span className="text-white/60">After-hours urgent work — please enquire.</span></span>
            </li>
            <li className="flex items-start gap-2">
              <Facebook className="mt-0.5 h-4 w-4 flex-none text-brand" />
              <a href="https://www.facebook.com/coolwavenz" target="_blank" rel="noreferrer" className="min-w-0 flex-1 [overflow-wrap:anywhere] hover:text-brand">facebook.com/coolwavenz</a>
            </li>
            <li className="flex items-start gap-2">
              <Instagram className="mt-0.5 h-4 w-4 flex-none text-brand" />
              <a href="https://www.instagram.com/coolwavenz" target="_blank" rel="noreferrer" className="min-w-0 flex-1 [overflow-wrap:anywhere] hover:text-brand">instagram.com/coolwavenz</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container flex flex-col items-center justify-between gap-2 py-5 text-xs text-white/60 sm:flex-row">
          <p>© Cool Wave Ltd — All Rights Reserved · Mangawhai, New Zealand</p>
          <p>Certified Panasonic Installer</p>
        </div>
      </div>
    </footer>
  );
}
